<template>
  <div class="p-4 bg-[var(--fundoForm)] rounded-lg shadow-md">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Campo -->
      <div class="flex flex-col">
        <label for="campo" class="text-[var(--text)] mb-1">Campo</label>
        <input
          id="campo"
          v-model="form.campo"
          type="text"
          placeholder="Digite o campo"
          class="rounded-md border px-3 py-1 text-sm text-black"
        />
      </div>

      <!-- Tipo -->
      <div class="flex flex-col">
        <label for="tipo" class="text-[var(--text)] mb-1">Tipo</label>
        <select
          id="tipo"
          v-model="form.tipo"
          class="rounded-md border px-3 py-1 text-sm bg-white text-black"
        >
          <option v-for="opt in tipos" :key="opt" :value="opt">{{ opt }}</option>
        </select>
      </div>
    </div>

    <!-- Botões -->
    <div class="mt-4 flex space-x-2">
      <button
        @click="save"
        class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-1 rounded-lg"
      >
        {{ isEdit ? 'Atualizar' : 'Criar' }}
      </button>
      <button
        v-if="isEdit"
        @click="remove"
        class="bg-red-500 hover:bg-red-600 text-white px-4 py-1 rounded-lg"
      >
        Eliminar
      </button>
      <button
        @click="$emit('cancel')"
        class="bg-gray-500 hover:bg-gray-600 text-[var(--text)] px-4 py-1 rounded-lg"
      >
        Cancelar
      </button>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, watch } from 'vue'
import axios from 'axios'

const baseURL = process.env.VUE_APP_URL_BASE
axios.defaults.baseURL = baseURL

const props = defineProps({
  mode: { type: String, default: 'create' },
  initialData: {
    type: Object,
    default: () => ({
      id: null,
      tpSeparador_id: null,
      campo: '',
      tipo: 'number'
    })
  }
})
const emit = defineEmits(['saved', 'deleted', 'cancel'])

const isEdit = computed(() => props.mode === 'edit')
const tipos = ['number', 'text', 'double', 'data', 'boolean']

const form = reactive({
  tpSeparador_id: props.initialData.tpSeparador_id,
  campo: props.initialData.campo,
  tipo: props.initialData.tipo
})

// Watch para sincronizar o form quando initialData mudar
watch(
  () => props.initialData,
  (newVal) => {
    form.tpSeparador_id = newVal.tpSeparador_id
    form.campo = newVal.campo
    form.tipo = newVal.tipo
  },
  { deep: true, immediate: true }
)

async function save() {
  const endpoint = isEdit.value
    ? `api/v1/campo_separador/${props.initialData.id}/`
    : `api/v1/campo_separador/`
  try {
    if (isEdit.value) {
      await axios.put(endpoint, {
        campo: form.campo,
        tipo: form.tipo
      })
    } else {
      await axios.post(endpoint, {
        tpSeparador_id: form.tpSeparador_id,
        campo: form.campo,
        tipo: form.tipo
      })
    }
    emit('saved')
  } catch (error) {
    console.error('API error:', error.response?.data || error.message)
  }
}

async function remove() {
  if (!isEdit.value) return
  const endpoint = `api/v1/campo_separador/${props.initialData.id}/`
  try {
    await axios.delete(endpoint)
    emit('deleted')
  } catch (error) {
    console.error('API error:', error.response?.data || error.message)
  }
}
</script>
